import $ from 'jquery';
const ELEMENT_SELECTOR = '.js__collection-items-value-on-change';
export class CollectionItemsValuesOnChange {
    static init($root = $('body')) {
        const $element = $root.find(ELEMENT_SELECTOR);
        if (!$element.length) {
            return;
        }
        this.initActions($element);
    }
    static initActions($element) {
        $element.on('change', e => {
            const $element = $(e.currentTarget).find('[data-target]');
            const { target, onValues, defaultValues } = $element.data();
            $.each(onValues, (index, onValue) => {
                if ($element.val() === onValue) {
                    this.selectValues($(target), defaultValues[index]);
                }
            });
        });
    }
    static selectValues($element, values) {
        const $deleteButtons = $element.find('[data-form-collection="delete"]');
        if ($deleteButtons.length) {
            $deleteButtons.trigger('click');
        }
        $.each(values, (index, value) => {
            $element.find('.js__add-action').trigger('click');
            const $collectionItem = $($element.find(`[data-form-collection="item"]`).get(index));
            const $input = $collectionItem.find('input');
            $input.val(value);
        });
    }
}
